import { updateGreetingError } from "../../redux/actions/InfoActions";
import store from "../../redux/store";
import { OPENING_HOURS_KEY } from "../knowledge-base/knowledge-base-logic";

export const hasChangesInYourReceptionist = () => {
  const { voice, updatedVoice, greeting, updatedGreeting } = store.getState().info;

  if (voice !== updatedVoice) {
    return true;
  }

  if (greeting !== updatedGreeting) {
    return true;
  }

  return false;
};

export const validateYourReceptionist = () => {
  const { updatedGreeting } = store.getState().info;

  if (updatedGreeting === "") {
    store.dispatch(updateGreetingError("Greeting is required"));
    return { valid: false, type: "no-greeting", message: "Greeting is required", elementId: "greeting-section" };
  }

  return { valid: true };
};

// TODO: Refactor this to use the same logic as KnowledgeBase
export const getSetupSaveObject = () => {
  const { updatedGreeting, updatedVoice, setup } = store.getState().info;
  const knowledgeBase = store.getState().knowledgeBase;

  if (!setup || !knowledgeBase) {
    return {};
  }

  var openingHoursObject = knowledgeBase.updatedKnowledgeBaseItems.find((item) => item.type === OPENING_HOURS_KEY);
  var openingHoursValue = openingHoursObject ? openingHoursObject.value : [];

  return {
    greeting: updatedGreeting?.trim(),
    voice: updatedVoice,
    openingHours: openingHoursValue,
  };
};
